<!--
 * @Description: 活动列表
 * @Date: 2022-02-25 10:28:33
-->
<template>
  <table-render
    ref="tableRender"
    :config="config"
    :propData="propData"
    pageLayout="total, sizes, prev, pager, next, jumper"
  />
</template>
<script>
import tableRender from '@/components/tableRender';
import config from './config/index.js';
import _ from 'lodash';
import baseRowLink from '@C/Base/baseRowlink';

export default {
  name: 'activeList',
  provide() {
    return {
      indexPage: this,
      _parent: this
    };
  },
  components: { tableRender },
  data: () => ({
    config: [],
    propData: {
      query: {
        projectId: 0
      }
    }
  }),
  created() {
    const { id, fileUpSource } = this.$store.state.homeProject;
    this.propData = {
      query: {
        projectId: id
      }
    };

    let configPoint = _.cloneDeep(config);
    if (+fileUpSource === 3) {
      // 双方共同上传 增加这个字段
      configPoint[0].childMenu[0].fields.splice(3, 0, {
        label: '参与人提交任务数',
        prop: 'submitTheNumber',
        render: (h, ctx, row) => {
          return row.submitTheNumber > 0 ? (
            h(baseRowLink, {
              props: {
                text: row.submitTheNumber
              },
              on: {
                click: () => {
                  this.$router.replace({
                    query: {
                      ...this.$route.query,
                      activeTask: 'recordList',
                      activityName: row.activityName
                    }
                  });
                }
              }
            })
          ) : (
            <span>0</span>
          );
        }
      });

      this.config = configPoint;
    } else {
      this.config = config;
    }
  }
};
</script>

<style scoped></style>
